export default function findDefaultGlass(glasses, materialId) {
	let result = glasses.filter((glass) => glass.materialIds.includes(materialId) && glass.price === 0);

	return {
		id: result[0].id,
		name: result[0].name,
		price: result[0].price
	};
}
